export default class SignupInfo {
  public firstName: string = "";
  public lastName: string = "";
  public username: string = "";
  public email: string = "";
  public password: string = "";
  public organizationCode: string = "";
  public accountConfirmationUrl: string = "";
}
